import axios from '@axios'
import JwtService from './jwtService'

export default new JwtService(axios, {
  loginEndpoint: '/oauth/token',
  registerEndpoint: '/jwt/register',
  refreshEndpoint: '/oauth/token',
  logoutEndpoint: '/logout',
})
